// Taken from https://stackoverflow.com/a/3291856/3192470
const capitalize = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default capitalize
